(function($) {
    $(document).ready(function () {
        const burger = $('.hamburger');
        const nav = $('.primary-nav-container');

        // burger.click(function() {
        //    nav.slideToggle();
        // });

        if ($(window).width() > 1024) {
            showMenu();
        } else {
            hideMenu();
        }

        burger.click(function () {
            $(this).toggleClass('is-active');
            showOrHideMenu();
        });

        $(window).resize(function() {
            if ($(window).width() > 1024) {
                showMenu();
            } else {
                showOrHideMenu();
            }
        });

        function showOrHideMenu() {
            if (burger.hasClass('is-active')) {
                showMenu();
            } else {
                hideMenu();
            }
        }

        function showMenu() {
            nav.slideDown();
        }

        function hideMenu() {
            nav.slideUp();
        }
    });
})(jQuery, this);
